import axios from "axios";
import { UserResponse } from "./interfaces/UserResponse";


export const getCurrentUser = () => {
    return axios.get<UserResponse>('/ajax', {
        params: { datasource: 'systemGetUserData' },
    });
}